<script>
  export let expanded = false
  export let name
  export let items = []
  export let canProcess
  export let sub
  export let onChange = null
  export let uuid = ''
  export let onInfo = null
</script>
  
<div class:div={sub}>
  <span
    class:caret={items}
    class:caret-down={expanded}
    class:caret-main={!sub}
    on:click={() => expanded = !expanded}
>
    {name}
  </span> <a href="info" on:click|preventDefault={() => onInfo(uuid)}>{uuid}</a>
  {#if sub}<input type="checkbox" bind:checked={canProcess} on:change={onChange}/>{/if}
</div>

{#if expanded}
  <ul>
    {#each items as {canProcess, name, expanded, children, uuid}}
      <li><svelte:self sub {onChange} bind:canProcess items={children} {name} bind:expanded {uuid} {onInfo} /></li>
    {/each}
  </ul>
{/if}
  


<style>

input {
  /*float: right;*/
}

ul {
    padding: 0;
    margin: 0;
    list-style-type: none;
    position: relative;
}

li {
    list-style-type: none;
    border-left: 2px solid #000;
    margin-left: 1em;
}

ul > li:last-child {
    border-left: 2px solid transparent;
}

span {
  margin-left: -2px;
  position: relative;
  z-index: 2;
}

.div {
    padding-left: 1em;
    position: relative;
}

.div::before {
    content: '';
    position: absolute;
    top: 0;
    left: -2px;
    bottom: 50%;
    width: 0.65em;
    border: 2px solid #000;
    border-top: 0 none transparent;
    border-right: 0 none transparent;
}

  /* Style the caret/arrow */
.caret {
  cursor: pointer;
  user-select: none; /* Prevent text selection */
  margin-left: -18px
}

/* Create the caret/arrow with a unicode, and style it */
.caret::before {
  content: "\25B6";
  color: black;
  display: inline-block;
  margin-right: 0px;
  /*font-family: "Times New Roman", Times, serif;*/
  font-size: 116%;
}

/* Rotate the caret/arrow icon when clicked on (using JavaScript) */
.caret-down::before {  
  content: "\25BC";
  margin-right: 5px;
}

.caret-down {
  margin-left: -25px;
}

.caret-main {
  margin-left: 7px
}

</style>